import React, { useState } from "react";

const MessageSentPopup = ({ isOpen = false, isSuccess = false, onClose }) => {

	const modalBgColor = isSuccess ? "bg-green-500" : "bg-red-500";
	const close = () => {
		if (onClose) onClose();
	};

	return (
		isOpen && (
			<div className={`absolute top-0 left-0 w-full h-full p-6  z-[50] flex items-center justify-center `}>
				<div onClick={close} className="absolute inset-0 bg-[rgba(0,0,0,0.5)] "></div>
				<div className={` relative z-2 rounded-md p-6 ${modalBgColor} text-white`}>
					{isSuccess ? (
						<div className="flex flex-col items-center justify-center">
							<h2 className="sm:text-[1.5rem] text-2xl text-center font-bold">Message Sent Successfully!</h2>
						</div>
					) : (
						<div className="flex flex-col items-center justify-center">
							<h2 className=" sm:text-[1.5rem] text-2xl font-bold mb-4">Failed to Send Message</h2>
							<p>There was an error while trying to send your message.</p>
						</div>
					)}
				</div>
			</div>
		)
	);
};

export default MessageSentPopup;
